import React from 'react';

export const FourPointedStarIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    min="fit-content"
  >
    <path
      d="M10.0057 16.3996C9.85699 16.3997 9.71124 16.3583 9.58477 16.2802C9.4583 16.202 9.35611 16.0902 9.28965 15.9572L7.54325 12.462L4.04725 10.7156C3.91413 10.6493 3.80213 10.5471 3.72385 10.4206C3.64557 10.2941 3.60411 10.1483 3.60411 9.9996C3.60411 9.85086 3.64557 9.70506 3.72385 9.57858C3.80213 9.4521 3.91413 9.34995 4.04725 9.2836L7.54325 7.5372L9.28965 4.0412C9.56165 3.4996 10.4497 3.4996 10.7217 4.0412L12.4681 7.5372L15.9641 9.2836C16.0972 9.34995 16.2092 9.4521 16.2875 9.57858C16.3657 9.70506 16.4072 9.85086 16.4072 9.9996C16.4072 10.1483 16.3657 10.2941 16.2875 10.4206C16.2092 10.5471 16.0972 10.6493 15.9641 10.7156L12.4681 12.462L10.7217 15.958C10.6551 16.0908 10.5528 16.2025 10.4264 16.2805C10.2999 16.3585 10.1542 16.3997 10.0057 16.3996ZM6.19445 9.9996L8.49685 11.15C8.65205 11.2276 8.77685 11.3532 8.85525 11.5084L10.0057 13.8108L11.1561 11.5084C11.2337 11.3532 11.3593 11.2284 11.5145 11.15L13.8169 9.9996L11.5145 8.8492C11.3593 8.77169 11.2336 8.64592 11.1561 8.4908L10.0057 6.1884L8.85525 8.4908C8.77765 8.646 8.65205 8.7708 8.49685 8.8492L6.19445 9.9996ZM3.59365 3.5292L4.39365 1.9292L5.19365 3.5292L6.79365 4.3292L5.19365 5.1292L4.39365 6.7292L3.59365 5.1292L1.99365 4.3292L3.59365 3.5292Z"
      fill="white"
    />
  </svg>
);
